var err_style = '';

$(document).ready( function() {
  var options = { errorClass: 'mce_inline_error', errorElement: 'div', errorStyle: err_style, onkeyup: function(){}, onfocusout:function(){}, onblur:function(){}  };
  var mce_validator = $(".signup-form").validate(options);
  options = { url:'//novisnyc.us5.list-manage.com/subscribe/post-json?u=3f0ffd53d9ef37dd0a65d0fa3&id=000a6f72ed&c=?', type: 'GET', dataType: 'json', contentType: "application/json; charset=utf-8",
                beforeSubmit: function(){
                    $('#mce_tmp_error_msg').remove();
                    $('.datefield','#mc_embed_signup').each(
                        function(){
                            var txt = 'filled';
                            var fields = new Array();
                            var i = 0;
                            $(':text', this).each(
                                function(){
                                    fields[i] = this;
                                    i++;
                                });
                            $(':hidden', this).each(
                                function(){
                                	if ( fields[0].value=='MM' && fields[1].value=='DD' && fields[2].value=='YYYY' ){
                                		this.value = '';
									} else if ( fields[0].value=='' && fields[1].value=='' && fields[2].value=='' ){
                                		this.value = '';
									} else {
	                                    this.value = fields[0].value+'/'+fields[1].value+'/'+fields[2].value;
	                                }
                                });
                        });
                    return mce_validator.form();
                }, 
                success: mce_success_cb
            };
  $('.signup-form').ajaxForm(options);

});

function mce_success_cb(resp){
	if (resp.result=="success"){
		$('input.your-email').val('').attr('placeholder','Thank You!');
	} else {
		$('input.your-email').val('').attr('placeholder','Please Re-enter');
	}
}